/*
 * @Description: common client methods
 * @Author: Rfan
 * @Date: 2020-06-11 14:29:50
 * @LastEditTime: 2025-07-08 17:49:19
 */
/**
 * @module client/index 
 */

/** 
 * 调取客户端方法
 * @fileoverview 调取客户端方法
 * @author Rfan
 */

import { testPlatform } from "@/utils";
/**
 * @typedef {Object} userInfo
 * @property {number} userId - userId
 * @property {string} token token
 * @property {string} nick 姓名
 * @property {string} avatar 头像
 */


export function receiveGetInfo() {
  console.log('receive');
  window.hsj.getUserInfo();
  window.hsj.getVerInfo();
}

/**
 * @description 获取会员信息
 * @function
 * @returns {userInfo} 会员信息
 * @see {@link userInfo}
 */

export function getUserInfo() {
  return window.hsj.getUserInfo();
}

/**
 * @typedef {Object} verInfo
 * @property {number} verCode 版本号
 * @property {string} verName 版本名字
 */
/**
 * 安卓获取软件版本信息
 * @returns {verInfo} 软件版本信息
 */
export function getAppVerInfo() {
  return window.hsj.getVerInfo();
}

/**
 * 客户端主动调取——用户信息回调
 * @param {string} data JSON
 */
export function getUserInfoSuccess(data) {
  console.log('getUserInfoSuccess: ', data);
  const vueNode = app.__vue__;
  if (vueNode.$children[0].userInfoCb) {
    vueNode.$children[0].userInfoCb(data)
  } else {
    vueNode.userInfoCb(data)
  }
}

/**
 * 客户端主动调取——用户登录成功回调
 * @param {string} data JSON
 */
export function loginSuccess(data) {
  console.log('loginSuccess: ', data);
  const vueNode = app.__vue__;
  if (vueNode.$children[0]?.$children[0]?.loginSuccess) {
    vueNode.$children[0].$children[0].loginSuccess(data)
  } else if (vueNode.$children[0].loginSuccess) {
    vueNode.$children[0].loginSuccess(data)
  } else if (vueNode.$children[0]?.$children[0]?.$children[0]?.loginSuccess){
    vueNode.$children[0].$children[0].$children[0].loginSuccess(data)
  } else {
    vueNode.loginSuccess(data)
  }
}

/**
 * 客户端主动调取——用户下载模版并打开回调
 * @param {string} data JSON
 */
 export function templateInstallAndOpenCallBack(data) {
  console.log('templateInstallAndOpenCallBack: ', data);
  const vueNode = app.__vue__;
  if (vueNode.$children[0].templateInstallAndOpenCallBack) {
    vueNode.$children[0].templateInstallAndOpenCallBack(data)
  } else {
    vueNode.templateInstallAndOpenCallBack(data)
  }
}

/**
 * 客户端主动调取——软件版本信息回调
 * @param {string} data JSON
 */
export function getAppVerInfoSuccess(data) {
  console.log('getAppVerInfoSuccess: ', data);
  const vueNode = app.__vue__;
  if (vueNode.$children[0].versionCb) {
    vueNode.$children[0].versionCb(data)
    
  } else {
    vueNode.versionCb(data)
  }
}

/**
 * 打开客户端个人中心
 * @param {Number} id 
 * @return: 
 */
export function gotoUserCenter(id) {
  if (testPlatform("ios")) {
    console.log("user ios ", id);
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler("gotoUserCenter", id, function () { });
    });
  } else {
    console.log("user android ", id);
    window.hsj.gotoUserCenter(id);
  }
}

/**
 * 客户端主动调用 设置安全区域。
 * @param {*} callback 
 * @returns 
 */
 export function setMargins(params) {
  const vueNode = app.__vue__;
  console.log("setMargin: ", params);
  if (vueNode.$children[0].setMargins) {
    vueNode.$children[0].setMargins(JSON.parse(params));
  } else if (vueNode.setMargins){
    vueNode.setMargins(JSON.parse(params));
  }
}

/*  ------  🍎 ios  ------  */
/**
 * This callback type is called `requestCallback` and is displayed as a global symbol.
 *
 * @callback iosCallback
 * @param {any} func 需要执行的方法
 */

/**
 * 🍎ios客户端方法
 * @param {iosCallback} callback - The callback that handles the response.
 */
export function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement("iframe");
  WVJBIframe.style.display = "none";
  WVJBIframe.src = "https://__bridge_loaded__";
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
}

/**
 *  转移页面客户端返回用户信息滞后时主动调取方法
 */
export function getBindInfo() {
  const vueNode = app.__vue__;
  console.log('router name', vueNode.$route.name);
  if (vueNode.$route.name && vueNode.$route.name === 'activatevipIndex') {
    console.log('bind node', vueNode.$children[0].$children[0]);
    vueNode.$children[0].$children[0].getVipInfo();
  }
  if (vueNode.$route.name && vueNode.$route.name === 'Christmas2023') {
    console.log('bind node', vueNode.$children[0]);
    vueNode.$children[0].updatedUserInfo();
  }
  if (vueNode.$route.name && vueNode.$route.name === 'SpringFestival2024') {
    console.log('bind node', vueNode.$children[0]);
    vueNode.$children[0].updatedUserInfo();
  }
}

/**
 * 客户端主动调取——上传图片成功回
 * @param {string} imgAddr 图片url
 */
 export function uploadImgSuccess(imgAddr) {
  let data = imgAddr;
  try {
    const dataObj = JSON.parse(imgAddr);
    if (!(dataObj instanceof Array)) {
      data = [imgAddr];
    } else {
      const strList = [];
      dataObj.map(item => {
        let itemObj = item
        try {
          itemObj = JSON.parse(item);
        } catch (e) {
          // strList.push(item);
        }
        strList.push(itemObj);
      });
      data = strList;
    }
  } catch (err) {
    data = [imgAddr];
    console.log(err);
  }

  const vueNode = app.__vue__;
  if (vueNode.$route.name === "SupplementaryReport" && vueNode.$children[0].uploadImgSuccess) {
    vueNode.$children[0].uploadImgSuccess(data);
  }
}
/**
 * 客户端主动调取——🆕新版笔刷安装成功回调
 * @param {string} data 笔刷状态
 */
export function installNewBrushSuccess(data) {
  console.log("new bursh installed: ", data);
  const vueNode = app.__vue__;
  const pageList = new Set(["HsjproBrushFree2026"]);
  if (pageList.has(vueNode.$route.name)) {
    vueNode.$refs.view.$children[0].$children[0].installNewBrushSuccess(JSON.parse(data));
  }
}
/**
 * 客户端主动调取——笔刷安装成功回调
 * @param {string} data 笔刷状态
 */
export function installBrushSuccess(data) {
  console.log("bursh installed: ", data);

  const vueNode = app.__vue__;
  const pageList = new Set(["HsjproBrushFree2026"]);
  if (pageList.has(vueNode.$route.name)) {
    vueNode.$refs.view.$children[0].$children[0].installNewBrushSuccess(JSON.parse(data));
  }
}

/**
 * 客户端主动调取——获取笔刷安装状态成功回调
 * @param {string} data JSON
 */
export function queryBrushesComplete(data) {
  console.log("query brush: ", data);

  const vueNode = app.__vue__;
  const pageList = new Set(["HsjproBrushFree2026"]);
  if (pageList.has(vueNode.$route.name)) {
    vueNode.$refs.view.$children[0].$children[0].updateBrushState(JSON.parse(data));
  }
}